module.exports = __webpack_public_path__ + "static/img/identity-handhold.d8ba127f.png";